module.exports = __webpack_public_path__ + "static/media/background-playlist-image-4.adb9d6bb.svg";